import { Form, FormRule } from "antd";
import Input, { TextInputProps } from "../TextInput/TextInput";

export default function FormItem({
  name,
  inputConfig,
  label,
  rules,
}: {
  name: string;
  label: string
  htmlFor?: string;
  inputConfig: TextInputProps;
  rules?: FormRule[];
}) {
  return (
    <Form.Item name={name} rules={rules} label={label} >
      <Input
        {...inputConfig}
        classes={`${inputConfig.className ?? '!bg-white !rounded-[14px] '} !h-[52px] !outline-none !border !border-gray-300 rounded-[14px] focus:!border-primaryGreen rounded-lg w-full`}
      />
    </Form.Item>
  );
}
